/**
 * CROSS-REPO CONTRACT — DO NOT CHANGE.
 *
 * The ParkApp website (`www`) sends a signed-in visitor to `{APP_URL}/auth/handoff?token=<TOKEN>`.
 * It is the shop handoff run the other way: the same single-use token, spent with the same mutation.
 *
 * These constants are deliberately kept OUT of `ROUTE_PATHS` / `RouteName` so a
 * repo-wide route rename never sweeps them up.
 * Changing either value silently breaks the sign-in handed over by the website.
 */
export const HANDOFF_ROUTE_PATH = '/auth/handoff';

export const HANDOFF_TOKEN_QUERY_PARAM = 'token';
